const calculateMonthlyLiabilities = (details) => {
    const totalCreditAmount = details.forRealEstateCreditsAmount + details.forConsumerCreditsAmount;
    if (totalCreditAmount === 0 || details.avgIncome === 0) {
        return 0;
    }
    return ((totalCreditAmount / details.avgIncome) * 100).toFixed(2);
};
export default calculateMonthlyLiabilities;
